/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Default_TitleInputs */

const en_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Iowa's Most Awarded Golf Instructor`)
};

const es_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | El instructor de golf más premiado de Iowa`)
};

const de_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Iowas meistausgezeichneter Golflehrer`)
};

const zh_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | 爱荷华州最受赞誉的高尔夫教练`)
};

const ar_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | أكثر مدربي الغولف تكريماً في Iowa`)
};

const fr_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | L'instructeur de golf le plus récompensé de l'Iowa`)
};

const vi_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Huấn luyện viên golf được vinh danh nhiều nhất Iowa`)
};

const sw_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Mkufunzi wa Gofu Aliyetuzwa Zaidi wa Iowa`)
};

const th_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | ครูสอนกอล์ฟที่ได้รับรางวัลมากที่สุดของรัฐไอโอวา`)
};

const bs_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Najnagrađivaniji instruktor golfa u Iowi`)
};

const ja_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Iowaで最も多くの賞を受けたゴルフインストラクター`)
};

const ko_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Iowa 최다 수상 골프 강사`)
};

const pt_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | O instrutor de golfe mais premiado de Iowa`)
};

const it_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | L’istruttore di golf più premiato dell’Iowa`)
};

const sv_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Iowas mest prisbelönta golfinstruktör`)
};

const nl_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | De meest bekroonde golfinstructeur van Iowa`)
};

const da_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Iowas mest prisbelønnede golfinstruktør`)
};

const nb_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Iowas mest prisbelønte golfinstruktør`)
};

const fi_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Iowan palkituin golfvalmentaja`)
};

const pl_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Najbardziej utytułowany instruktor golfa w Iowa`)
};

const ru_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Самый титулованный инструктор по гольфу в Iowa`)
};

const tr_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Iowa'nın En Çok Ödül Alan Golf Eğitmeni`)
};

const hi_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Iowa के सबसे अधिक सम्मानित गोल्फ प्रशिक्षक`)
};

const id_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Instruktur Golf Paling Berprestasi di Iowa`)
};

const ms_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Jurulatih Golf Paling Banyak Menerima Anugerah di Iowa`)
};

const cs_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Nejvíce oceňovaný golfový instruktor v Iowě`)
};

const el_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Ο πιο βραβευμένος προπονητής γκολφ της Iowa`)
};

const he_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | מדריך הגולף המוערך ביותר באיווה`)
};

const af_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Iowa se mees bekroonde gholfinstrukteur`)
};

const hu_meta_default_title = /** @type {(inputs: Meta_Default_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Egly Golf | Iowa legtöbbet díjazott golfoktatója`)
};

/**
* | output |
* | --- |
* | "Mark Egly Golf \| Iowa's Most Awarded Golf Instructor" |
*
* @param {Meta_Default_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const meta_default_title = /** @type {((inputs?: Meta_Default_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Default_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_default_title(inputs)
	if (locale === "de") return de_meta_default_title(inputs)
	if (locale === "zh") return zh_meta_default_title(inputs)
	if (locale === "ar") return ar_meta_default_title(inputs)
	if (locale === "fr") return fr_meta_default_title(inputs)
	if (locale === "vi") return vi_meta_default_title(inputs)
	if (locale === "sw") return sw_meta_default_title(inputs)
	if (locale === "th") return th_meta_default_title(inputs)
	if (locale === "bs") return bs_meta_default_title(inputs)
	if (locale === "ja") return ja_meta_default_title(inputs)
	if (locale === "ko") return ko_meta_default_title(inputs)
	if (locale === "pt") return pt_meta_default_title(inputs)
	if (locale === "it") return it_meta_default_title(inputs)
	if (locale === "sv") return sv_meta_default_title(inputs)
	if (locale === "nl") return nl_meta_default_title(inputs)
	if (locale === "da") return da_meta_default_title(inputs)
	if (locale === "nb") return nb_meta_default_title(inputs)
	if (locale === "fi") return fi_meta_default_title(inputs)
	if (locale === "pl") return pl_meta_default_title(inputs)
	if (locale === "ru") return ru_meta_default_title(inputs)
	if (locale === "tr") return tr_meta_default_title(inputs)
	if (locale === "hi") return hi_meta_default_title(inputs)
	if (locale === "id") return id_meta_default_title(inputs)
	if (locale === "ms") return ms_meta_default_title(inputs)
	if (locale === "cs") return cs_meta_default_title(inputs)
	if (locale === "el") return el_meta_default_title(inputs)
	if (locale === "he") return he_meta_default_title(inputs)
	if (locale === "af") return af_meta_default_title(inputs)
	if (locale === "hu") return hu_meta_default_title(inputs)
	return en_meta_default_title(inputs)
});